module.exports = __webpack_public_path__ + "img/noAppointment.cba0b291.png";